module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Contents",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong6#_idTextAnchor010"
    }
  }, [_vm._v("Author’s Foreword")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong7#_idTextAnchor013"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link2"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong7#_idTextAnchor013"
    }
  }, [_vm._v("Introduction: Saving Half Your Life")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong8#_idTextAnchor016"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong8#_idTextAnchor016"
    }
  }, [_c('span', {
    staticClass: "Small-CAP"
  }, [_vm._v("one:")]), _c('span', {
    staticClass: "ALL-CAP CharOverride-4"
  }), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_vm._v("Strangers No More")])]), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong9#_idTextAnchor019"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong9#_idTextAnchor019"
    }
  }, [_c('span', {
    staticClass: "Small-CAP"
  }, [_vm._v("two:")]), _c('span', {
    staticClass: "ALL-CAP CharOverride-4"
  }), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_vm._v("Feelings Just Are")])]), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong17#_idTextAnchor022"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong17#_idTextAnchor022"
    }
  }, [_c('span', {
    staticClass: "Small-CAP"
  }, [_vm._v("three:")]), _c('span', {
    staticClass: "ALL-CAP CharOverride-4"
  }), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_vm._v("Damages and Differences")])]), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong22#_idTextAnchor025"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong22#_idTextAnchor025"
    }
  }, [_c('span', {
    staticClass: "Small-CAP"
  }, [_vm._v("four:")]), _c('span', {
    staticClass: "ALL-CAP CharOverride-4"
  }), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_vm._v("Three Steps to Emotional Fitness")])]), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor005"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong25#_idTextAnchor028"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link1"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong25#_idTextAnchor028"
    }
  }, [_c('span', {
    staticClass: "Small-CAP"
  }, [_vm._v("five:")]), _c('span', {
    staticClass: "ALL-CAP CharOverride-4"
  }), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_vm._v("Care and Feeding of the Three Steps")])]), _c('span', {
    staticClass: "Bold _idGenCharOverride-2"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor006"
    }
  })]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong26#_idTextAnchor030"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong26#_idTextAnchor030"
    }
  }, [_vm._v("Permissions")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor007"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/NothingsWrong27#_idTextAnchor032"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "link"
  }, [_c('a', {
    attrs: {
      "href": "#/NothingsWrong27#_idTextAnchor032"
    }
  }, [_vm._v("About the Author")]), _c('a', {
    attrs: {
      "id": "_idTextAnchor008"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-774dfd48","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NothingsWrong-5.vue
// module id = 75
// module chunks = 0